import CurrenciesDropdown from './CurrenciesDropdown';
export default CurrenciesDropdown;